import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { selectCategory, updateSelectedCategory } from "../../../redux/slices/activityCategories";

import DOMPurify from "dompurify";
import { updateMegaSlider } from "../../../redux/slices/sidebarSliders";
import { useSelector } from "react-redux";
import { setUserActivity, toggleIsVideo, toggleVideoVisible } from "../../../redux/slices/userActivity";

export default function ActivityCategory({ id, icon, name, isSelected }) {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(selectCategory({ id }))
    dispatch(updateMegaSlider({
      active: false,
      activityTypeId: null,
      activitySubtypeId: null
    }))
    if (name === 'Video Activity') {
      console.log('selectedCategoryName', selectedCategoryName);
      if(selectedCategoryName === 'Video Activity') return
       dispatch(setUserActivity({ activities: [], defaultActivities: [] }))
    } else {
      dispatch(toggleIsVideo({ isVideo: false }))
      dispatch(toggleVideoVisible({ videoVisible: false }))
    }
  };
  const { categories, selectedCategoryName } = useSelector((state) => state.activityCategories);
  const { isEditing } = useSelector((state) => state.userActivity);

  useEffect(() => {
    categories.forEach(category => {
      if (category.isSelected === true) dispatch(updateSelectedCategory({ name: category.name }))
    })
  }, [categories])

  useEffect(() => {
    if (selectedCategoryName === 'Video Activity') {
      dispatch(toggleIsVideo({ isVideo: true }))
      // if (!isEditing) {
        dispatch(toggleVideoVisible({ videoVisible: true }))
      // }
      // dispatch(setUserActivity({ activities: [], defaultActivities: [] }))
    } else {
      dispatch(toggleIsVideo({ isVideo: false }))
      dispatch(toggleVideoVisible({ videoVisible: false }))
      // dispatch(setUserActivity({ activities: [{}], defaultActivities: [{}] }))
    }
  }, [selectedCategoryName, isEditing])

  const [svg, setSvg] = useState("");
  useEffect(() => {
    let url;
    if (icon.toString().includes("https")) {
      url = icon;
    } else {
      // url = icon.toString().replace("http", "http");
      url = icon
    }
    fetch(url)
      .then((r) => r.text())
      .then((text) => {
        setSvg(DOMPurify.sanitize(text));
      })
      .catch(console.error.bind(console));
  }, []);

  return (
    <div onClick={handleClick} className="activity_category">
      <div className={` activity_category__icon_container ${isSelected === true ? "activity_category__selected" : ""} `} dangerouslySetInnerHTML={{ __html: svg }}></div>
      <p className="activity_category__name"> {name} </p>
    </div>
  );
}
